import * as React from "react";
import { spacingToPixels } from "./spacing";
import { useStackContext } from "./index";
export var Spacer = function (_a) {
    var spacing = _a.spacing;
    var direction = useStackContext().direction;
    var style = {
        margin: 0
    };
    if (spacing) {
        if (direction === "column") {
            style.height = spacingToPixels(spacing) + "px";
        }
        else {
            style.width = spacingToPixels(spacing) + "px";
        }
    }
    else {
        style.flexGrow = 1;
    }
    return React.createElement("div", { style: style });
};
export default Spacer;
